import KuikaSvg from "../../components/ui-kit/kuika-svg/kuika-svg";
import { IScreenDesignContextState } from "../../contexts/screen-design-context/screen-design-context";

/**
 * Role icon for a screen id, matching the icon shown in the screens left-panel list.
 * Extracted from ScreensWindow so the row-2 screen selector renders identical icons
 * without duplicating the role→icon mapping.
 */
export const getScreenRoleIcon = (sd: IScreenDesignContextState, sdId: string, isManaged?: boolean): JSX.Element => {
  const isMasterScreen: boolean = sd.getMasterScreenId(sd.screenList) === sdId;
  if (isMasterScreen) {
    return <KuikaSvg id="screenRoleIcon-master" name="layout-board" width={16} height={16} />;
  }
  switch (sdId) {
    case sd.project.startingScreenId:
      return <KuikaSvg id="screenRoleIcon-starting" name="home" width={16} height={16} />;

    case sd.project.signinScreenId:
      return <KuikaSvg id="screenRoleIcon-signin" name="login-2" width={16} height={16} />;

    case sd.project.leftMenuScreenId:
      return <KuikaSvg id="screenRoleIcon-leftMenu" name="file" type="sidebar-icons" width={16} height={16} />;

    case sd.project.splashScreenId:
      return <KuikaSvg id="screenRoleIcon-splash" name="device-mobile" width={16} height={16} />;
    case sd.project.newPasswordScreenId:
      return <KuikaSvg id="screenRoleIcon-newPassword" name="lock-plus" width={16} height={16} />;
    case sd.project.verificationCodeScreenId:
      return <KuikaSvg id="screenRoleIcon-verificationCode" name="shield-check" width={16} height={16} />;
    case sd.project.offlineScreenId:
      return <KuikaSvg id="screenRoleIcon-offline" name="wifi-off" width={16} height={16} />;
    case sd.project.resetPasswordScreenId:
      return <KuikaSvg id="screenRoleIcon-resetPassword" name="lock-open-2" width={16} height={16} />;
    case sd.project.documentUploadLinkScreenId:
      return <KuikaSvg id="screenRoleIcon-documentUploadLink" name="upload" width={16} height={16} />;
    case sd.project.processStepScreenIds?.find((x) => x.screenId === sdId)?.screenId:
      return (
        <KuikaSvg
          id="screenRoleIcon-workflow"
          name="workflow-managed"
          type="workflow-icons"
          width={16}
          height={16}
          color={isManaged ? "var(--accent-fg)" : undefined}
        />
      );

    default:
      return <KuikaSvg id="screenRoleIcon-default" name="file" type="sidebar-icons" width={16} height={16} />;
  }
};
